
import { Component, Vue, Ref } from 'vue-property-decorator'
import { HelpService } from '@/services'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import TableList from '../../components/help/article_guide_table.vue'
@Component({
    components: {
        ScrollTo,
        TableList
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private list: any[] = []
    private typeList: any[] = []
    private isLoading = true

    async mounted() {
        await this.getList()
    }

    async getList() {
        this.isLoading = true
        const params = {
            page_index: this.pageIndex,
            page_size: this.pageSize,
            recommend: 1
        }
        const result = await HelpService.getArticles(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.list = result.data.list
        }
        this.isLoading = false
    }

    // 分页
    onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getList)
    }

    // 移出
    private onRemove(article: any) {
        this.$confirm('是否确定将该文章移出引导页?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.removeArticle(article)
        })
    }

    async removeArticle(article: any) {
        const params = { id: article.id, recommend: 0 }
        const result = await HelpService.updateArticle(params)
        if (result.status === 200) {
            this.list.splice(this.list.indexOf(article), 1)
            --this.pageTotal
            this.$message({
                type: 'success',
                message: '删除成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }
}
